export default "__VITE_ASSET__CP59cdAo__"